import { ChangeEventHandler, forwardRef, memo, TextareaHTMLAttributes, useCallback } from "react";
import { Input, InputProps } from "../Input";

export type TextAreaProps = Omit<InputProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, "component" | "onChange" | "value"> & {
  onChange?: (value: string | null) => void,
  value?: string | null
}

export const TextArea = memo(forwardRef<HTMLTextAreaElement, TextAreaProps>(({ onChange, value, ...props }, ref) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
    (e) => onChange?.(e?.target?.value || null),
    [ onChange ],
  );
  return (
    <Input
      {...props}
      value={value || ""}
      ref={ref}
      component={"textarea"}
      onChange={wrappedOnChange}
    />
  );
}));

export default TextArea;

